import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSmugmugComponent } from './simple-icons-smugmug.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSmugmugComponent ],
    exports:      [ SimpleIconsSmugmugComponent ],
    bootstrap:    []
})
export class SimpleIconsSmugmugModule {}
